/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SimInputNumberComponent as ɵa} from './input.component';